import Vue from 'vue'
//vue-echart就是一个组件 全局注册即可
import vcharts from "vue-echarts";
Vue.component('v-chart',vcharts)